import { render, staticRenderFns } from "./registerClient.vue?vue&type=template&id=040d4b9a"
import script from "./registerClient.vue?vue&type=script&lang=js"
export * from "./registerClient.vue?vue&type=script&lang=js"
import style0 from "./registerClient.vue?vue&type=style&index=0&id=040d4b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports